import { CircularProgress, Grid, Typography } from '@mui/material';
import { Alert } from '@mui/material';
import { Drawer } from 'modules/global/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetContainerDetail } from '../../adapters/assign-pickup/queries';
import { numberFields, fields, greenLightFields } from '../../constants/shared/detailFields';
import useStyles from './styles';

type Props = {
  containerId: string;
};

const ContainerDetailDrawer = ({ containerId }: Props) => {
  const { classes } = useStyles();
  const { t } = useTranslation(['changeTerminal', 'validation']);
  const { data: containerDetail, isError, isLoading } = useGetContainerDetail(containerId);

  return (
    <div className={classes.detailWrapper}>
      {!isLoading ? (
        <React.Fragment>
          <Typography variant="h1">{t('containerDetail.title')}</Typography>
          {isError && (
            <Alert severity="error" style={{ marginBottom: '16px' }}>
              {t('validation:errorGetContainerDetail')}
            </Alert>
          )}
          {containerDetail && (
            <Grid container direction="column" spacing={4}>
              <Grid>
                <Drawer.Content fieldModel={containerDetail} fields={numberFields} />
              </Grid>
              <Grid>
                <Drawer.Content fieldModel={containerDetail} fields={fields} />
              </Grid>
              <Grid>
                <Drawer.GreenLightContent fieldModel={containerDetail} fields={greenLightFields} />
              </Grid>
            </Grid>
          )}
        </React.Fragment>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
};

export default ContainerDetailDrawer;
export {};
